import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import formatISO from 'date-fns/formatISO'
import { getFavorites, toggleFavorite } from './favoriteApi'
import { transformFavoriteFiles } from 'utils/transform'

const favoriteAdapter = createEntityAdapter({
    selectId: file => file.fileId,
})

export const favoriteSelector = favoriteAdapter.getSelectors(state => state.favorites)
export const { selectAll } = favoriteAdapter.getSelectors(state => state.favorites)

export const getFavoriteFiles = createAsyncThunk('favorites/get', async (arg, thunkAPI) => {
    try {
        const response = await getFavorites(arg)
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const markFavorite = createAsyncThunk(
    'favorite/toggle',
    async ({ favourites }, thunkAPI) => {
        try {
            const response = await toggleFavorite({ favourites })
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

const initialState = favoriteAdapter.getInitialState({
    isLoading: false,
    isError: false,
    summary: { all: 0, image: 0, video: 0 },
    latestDateTime: null,
})

const updateTimestamp = array => {
    return array.map(f => ({
        ...f,
        updatedDateTime: formatISO(new Date()),
        isDownloadable: true,
    }))
}

const favoriteSlice = createSlice({
    name: 'favorites',
    initialState: initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getFavoriteFiles.pending, state => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getFavoriteFiles.fulfilled, (state, { payload }) => {
            if (payload.data) {
                favoriteAdapter.setAll(state, transformFavoriteFiles(payload.data.files))
                state.summary = payload.data.summary
                state.latestDateTime = payload.data.latestDateTime
            }
            state.isLoading = false
        })
        builder.addCase(getFavoriteFiles.rejected, state => {
            state.isLoading = false
            state.isError = true
        })
        builder.addCase(markFavorite.fulfilled, (state, { meta }) => {
            if (meta.arg.fav) {
                favoriteAdapter.addMany(state, updateTimestamp(meta.arg.favourites))
            } else {
                favoriteAdapter.removeMany(
                    state,
                    meta.arg.favourites.map(f => f.fileId)
                )
            }
            if (meta.arg.summary) {
                state.summary = meta.arg.summary
            }
            state.latestDateTime = meta.arg.summary?.all ? formatISO(new Date()) : null
        })
    },
})

export default favoriteSlice.reducer
